import { connect } from 'react-redux';
import ShippingPolicy from './ShippingPolicy';


let mapStateToProps = (state) => {
  return {
    shopName: state.aboutPage.aboutData.shopName,
    domain: state.aboutPage.aboutData.domain,
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const ShippingPolicyContainer = connect(mapStateToProps, mapDispatchToProps)(ShippingPolicy);

export default ShippingPolicyContainer;